import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-91680990"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["xlink:href", "fill"];
import { computed } from 'vue';
export default {
  __name: 'index',
  props: {
    className: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#409eff'
    },
    size: {
      type: String,
      default: '20px'
    }
  },
  setup(__props) {
    const props = __props;
    _useCssVars(_ctx => ({
      "304a2d22": props.size
    }));
    const classList = computed(() => {
      return ['icon', props.className || ''];
    });
    const iconName = computed(() => {
      return `#${props.iconClass}`;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(_unref(classList)),
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        "xlink:href": _unref(iconName),
        fill: __props.color
      }, null, 8, _hoisted_1)], 2);
    };
  }
};